'use client';

import { FC, useEffect, useState } from 'react';
import { useViewItemListEvent } from 'hooks/analytics/use-view-item-list-event';
const PDP_LIST_IDENTIFIER = 'PCC_PDP_PAGE';
interface Product {
  partNumber: string;
  name?: string;
  manufacturer?: string;
  availability?: Array<{ availabilityMessage: string }>;
  weight?: string | number;
  quantity?: number;
  price?: { unitPrice: number };
}

interface ProductAnalyticsProps {
  productCartPayload: {
    products: Product[];
    itemListData: {
      item_list_id: string;
      item_list_name: string;
    };
    isProductsData: boolean;
    productStatus: string;
    locationId?: string;
  };
}

export const ProductAnalytics: FC<ProductAnalyticsProps> = ({
  productCartPayload
}) => {
  const { fireEvent: fireViewItemListEvent } = useViewItemListEvent();
  const [gaEventAlreadyFired, setGaEventAlreadyFired] = useState(false);

  useEffect(() => {
    const { item_list_id, item_list_name } = productCartPayload.itemListData ?? {};
    const isPDPList = item_list_id === PDP_LIST_IDENTIFIER || item_list_name === PDP_LIST_IDENTIFIER;
    if (productCartPayload.products?.length > 0 && !gaEventAlreadyFired && !isPDPList) {
      const enhancedPayload = {
        ...productCartPayload,
        products: productCartPayload.products.map((product) => ({
          ...product,
          availability: product.availability || [{ availabilityMessage: '' }],
          weight: product.weight || '0',
          quantity: product.quantity || 1,
          price: product.price || { unitPrice: 0 }
        }))
      };

      fireViewItemListEvent(enhancedPayload);
      setGaEventAlreadyFired(true);
    }
  }, [productCartPayload, fireViewItemListEvent, gaEventAlreadyFired]);

  return null;
};
